import script from "./uploadFileDataCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadFileDataCollection.vue?vue&type=script&setup=true&lang=js"

import "./uploadFileDataCollection.vue?vue&type=style&index=0&id=60c74447&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c74447"]])

export default __exports__